/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumncountry2Inputs */

const en_signupscolumncountry2 = /** @type {(inputs: Signupscolumncountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

const de_signupscolumncountry2 = /** @type {(inputs: Signupscolumncountry2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Signupscolumncountry2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumncountry2 = /** @type {((inputs?: Signupscolumncountry2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumncountry2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumncountry2(inputs)
	return de_signupscolumncountry2(inputs)
});
export { signupscolumncountry2 as "signupsColumnCountry" }